import PageContent from '@/components/PageContent.vue'
import { ref } from 'vue'
import { downloadData } from '@/service/main/system'

type searchCallbackFn = (item?: any) => any

export function usePageSearch(
  resetCb?: searchCallbackFn,
  searchCb?: searchCallbackFn,
  afterSearchCb?: searchCallbackFn
) {
  const pageContentRef = ref<InstanceType<typeof PageContent>>()
  const handleResetClick = () => {
    if (resetCb) {
      pageContentRef.value?.getSearchPageData(resetCb())
    } else {
      pageContentRef.value?.getSearchPageData()
    }
  }

  // const handleSearchClick = (formdata: any) => {
  //   searchCb && searchCb({ ...formdata, pageNo: 1, pageSize: 1000 })
  //   pageContentRef.value?.getPageData(formdata, afterSearchCb)
  // }
  const handleSearchClick = (formdata: any) => {
    if (searchCb) {
      searchCb({ ...formdata, pageNo: 1, pageSize: 1000 })
    }
    pageContentRef.value?.getSearchPageData(formdata, afterSearchCb)
  }

  const handleDownBtnClick = (formdata: any) => {
    pageContentRef.value?.exportXlsx(formdata)
  }

  const handleSummaryBtnClick = (formdata: any) => {
    pageContentRef.value?.exportSummaryXlsx(formdata)
  }

  return [
    pageContentRef,
    handleResetClick,
    handleSearchClick,
    handleDownBtnClick,
    handleSummaryBtnClick
  ]
}
